
<template>
  <div class="base-timer">
    <svg
      class="base-timer__svg"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g class="base-timer__circle">
        <circle class="base-timer__path-elapsed" cx="50" cy="50" r="45" />
        <path
          :stroke-dasharray="circleDasharray"
          class="base-timer__path-remaining"
          :class="remainingPathColor"
          d="
            M 50, 50
            m -45, 0
            a 45,45 0 1,0 90,0
            a 45,45 0 1,0 -90,0
          "
        />
      </g>
    </svg>
    <div class="base-timer__inner">
      <span class="base-timer__time">{{ formattedTimeLeft }}</span>
      <span class="base-timer__label">HH:MM:SS</span>
    </div>
  </div>
</template>

<script>
const FULL_DASH_ARRAY = 283;
const WARNING_THRESHOLD = 10;
const ALERT_THRESHOLD = 5;

const COLOR_CODES = {
  info: {
    color: "green",
  },
  warning: {
    color: "orange",
    threshold: WARNING_THRESHOLD,
  },
  alert: {
    color: "red",
    threshold: ALERT_THRESHOLD,
  },
};

//const TIME_LIMIT = 1000;

export default {
  data() {
    return {
      timer: this,
      timePassed: 0,
      timerInterval: null,
      TIME_LIMIT: null,
    };
  },

  computed: {
    circleDasharray() {
      return `${(this.timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`;
    },

    formattedTimeLeft() {
      let timeLeft = this.timeLeft;
      let seconds = timeLeft % 60;
      timeLeft = parseInt(timeLeft / 60);
      let minutes = timeLeft % 60;
      timeLeft = parseInt(timeLeft / 60);
      let hours = timeLeft;

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      if (hours < 10) {
        hours = `0${hours}`;
      }

      return `${hours}:${minutes}:${seconds}`;
    },

    timeLeft() {
      //alert(this.TIME_LIMIT);
      return this.TIME_LIMIT - this.timePassed;
    },

    timeFraction() {
      const rawTimeFraction = this.timeLeft / this.TIME_LIMIT;
      return rawTimeFraction - (1 / this.TIME_LIMIT) * (1 - rawTimeFraction);
    },

    remainingPathColor() {
      const { alert, warning, info } = COLOR_CODES;

      if (this.timeLeft <= alert.threshold) {
        return alert.color;
      } else if (this.timeLeft <= warning.threshold) {
        return warning.color;
      } else {
        return info.color;
      }
    },
  },

  watch: {
    timeLeft(newValue) {
      if (newValue === 0) {
        this.onTimesUp();
      }
    },
  },

  mounted() {
    //this.startTimer();
  },

  methods: {
    onTimesUp() {
      this.clearTimer();
      this.$emit("onTimesUp", this);
    },

    startTimer() {
      this.timePassed = 0;
      this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
    },
    createTimer(timeLimit) {
      this.clearTimer();
      this.TIME_LIMIT = timeLimit;
      this.startTimer();
    },
    clearTimer() {
      if (this.timerInterval != null) {
        clearInterval(this.timerInterval);
      }
    },
    remainingTime() {
      return this.TIME_LIMIT - this.timePassed;
    },
  },
};
</script>

<style scoped lang="scss">
.base-timer {
  position: relative;
  width: 250px;
  height: 250px;

  &__svg {
    transform: scaleX(-1);
  }

  &__circle {
    fill: none;
    stroke: none;
  }

  &__path-elapsed {
    stroke-width: 7px;
    stroke: grey;
  }

  &__path-remaining {
    stroke-width: 7px;
    stroke-linecap: round;
    transform: rotate(90deg);
    transform-origin: center;
    transition: 1s linear all;
    fill-rule: nonzero;
    stroke: currentColor;

    &.green {
      //color: rgb(65, 184, 131);
      color: orange;
    }

    &.orange {
      color: orange;
    }

    &.red {
      color: red;
    }
  }

  &__inner {
    position: absolute;
    width: 250px;
    height: 250px;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 48px;
  }
  .base-timer__inner {
    color: orange;
    text-align: center;
  }
  .base-timer__label {
    color: #5e5e6e;
    text-align: center;
    font-size: 0.5em;
    font-weight: 500;
    position: absolute;
    margin-top: 40px;
  }
}
span.base-timer__label {
  position: relative !important;
  margin-top: 0px !important;
}
.base-timer .base-timer__inner {
  color: orange;
  text-align: center;
  top: 50%;
  transform: translateY(-45%);
  flex-direction: column;
  left: 0px;
  right: 0;
  margin: 0 auto;
}
span.base-timer__time {
  line-height: 1;
}
</style>
